import lapdev from '../../lapdev';

export function resetPasswordConfirm(data) {
  return lapdev.post('auth/confirm-password-reset', data);
}
